export default {
    namespaced: true,
    detection_event: {
      title: "evento de detecção|eventos de detecção",
      event_type: "tipo de evento",
      event_created_at: "Evento criado em",
      provider: "fornecedor",
      data: "facto",
      metadata:"metadados",
      media: "imagem",
      pause: 'Pausa',
      play: 'Jogar',
      playing: 'Jogando',
      update: 'Atualizar',
      ms_title: "ms evento de detecção|ms eventos de detecção",
      export_excel: "Exportar Excel",
      fire_smoke: {
        option: "Relatório de fogo e fumaça",
        modal_title: "Exportar relatório de fogo e fumaça",
        date_range: "Intervalo de datas",
        export: "Exportar",
        cancel: "Cancelar",
        select_range: "Selecione um intervalo de datas",
        export_error: "Erro ao exportar o relatório de fogo e fumaça",
      },
    },
  };
  